import { createBrowserRouter, RouterProvider } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { useState, useEffect } from 'react';
import TypesafeI18n from '@/i18n/i18n-react';
import { loadLocaleAsync } from '@/i18n/i18n-util.async';
import { detectUserLocale } from '@/lib/locale-utils';
import type { Locales } from '@/i18n/i18n-types';
import { queryClient } from './lib/query-client';
import { GlobalChartGradients } from './lib/chart-gradients';
import { routes } from './routes';

const router = createBrowserRouter(routes);

function App() {
  const [locale, setLocale] = useState<Locales>('en');
  const [localesLoaded, setLocalesLoaded] = useState(false);

  useEffect(() => {
    const detectedLocale = detectUserLocale();
    setLocale(detectedLocale);
    loadLocaleAsync(detectedLocale).then(() => setLocalesLoaded(true));
  }, []);

  if (!localesLoaded) {
    return null; // or a loading spinner
  }

  return (
    <QueryClientProvider client={queryClient}>
      <TypesafeI18n locale={locale}>
        <GlobalChartGradients />
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        <RouterProvider router={router} />
      </TypesafeI18n>
    </QueryClientProvider>
  );
}

export default App;
